import { Flex, Title, Select, Button, Grid, rem } from '@mantine/core';
import { useHistory, useLocation } from 'react-router-dom';
import { IconPlus } from '@tabler/icons-react';
import { useGetStores } from '../../hooks/stores/queries';
import { IStore } from '../../interfaces/Store';
import useValidStoreId from '../../hooks/useValidStoreId/useValidStoreId';
import { usePostHog } from 'posthog-js/react';
import { trackEvent } from '../../utils/monitoring/posthog';
import { MonitoringEventTypes } from '../../utils/monitoring/Monitoring_Events_Enum';
import SkeletonLine from '../Skeletons/SkeletonLine';

interface CatalogListHeaderProps {
  title: string;
  createButtonText?: string;
  onCreateButtonClick?: () => void;
  showCreateButton: boolean;
  showStoresList?: boolean;
  createButtonTestId?: string;
}

export default function CatalogListHeader({
  title,
  createButtonText,
  onCreateButtonClick = () => {},
  showCreateButton = false,
  showStoresList = true,
  createButtonTestId
}: CatalogListHeaderProps) {
  const posthog = usePostHog();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const searchParamStoreId: string | null = searchParams.get('storeId');
  const { isLoading: isGetStoresLoading, data: stores } = useGetStores();
  useValidStoreId();

  const onChangeSelectedStore = (storeId: string | null) => {
    const params = new URLSearchParams(location.search);
    params.set('storeId', storeId || '');
    history.replace({ pathname: location.pathname, search: params.toString() });
    trackEvent(posthog, MonitoringEventTypes.STORE_CHANGED_FROM_CRUD_PAGE_HEADER, {
      storeId: storeId
    });
  };

  return (
    <>
      <Grid align="center" mb={20}>
        <Grid.Col span={{ xs: 12, md: 9 }}>
          <Grid align="center" justify="flex-start">
            <Grid.Col span={{ xs: 12, md: 'content' }}>
              <Title order={1} mr={'md'}>
                {title}
              </Title>
            </Grid.Col>
            {isGetStoresLoading ? (
              <Grid.Col span={{ xs: 12, md: 'auto' }}>
                <SkeletonLine />
                <SkeletonLine />
              </Grid.Col>
            ) : (
              <>
                {showStoresList && (
                  <Grid.Col span={{ xs: 12, md: 'content' }}>
                    <Select
                      value={searchParamStoreId}
                      onChange={(val) => onChangeSelectedStore(val)}
                      allowDeselect={false}
                      placeholder={'Sucursal'}
                      data={
                        stores?.map((store: IStore) => {
                          return {
                            label: store.name,
                            value: store._id
                          };
                        }) || []
                      }
                    />
                  </Grid.Col>
                )}
              </>
            )}
          </Grid>
        </Grid.Col>
        {showCreateButton && (
          <Grid.Col span={{ xs: 12, md: 3 }}>
            <Flex justify={'flex-end'}>
              <Button
                data-testid={createButtonTestId}
                color="var(--mantine-color-washday-primary-9)"
                w={'100%'}
                size="md"
                leftSection={<IconPlus stroke={rem(4)} />}
                onClick={onCreateButtonClick}>
                {createButtonText?.toUpperCase()}
              </Button>
            </Flex>
          </Grid.Col>
        )}
      </Grid>
    </>
  );
}
